import { useTranslation } from 'react-i18next';
import BankIdIcon from 'assets/icons/ico-bankid.svg?react';

function TopSection({ handleButtonClick }: { handleButtonClick: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col xl:flex-row items-center xl:items-start justify-between gap-6">
      <div className="flex flex-col gap-4">
        <h1 className="font-medium text-2xl text-center xl:text-left">
          {t('bank_id:title')}
        </h1>
        <div className="flex flex-col">
          <p className="text-center xl:text-left">
            {t('bank_id:subtitle')}
            <button
              className="text-primary"
              type="button"
              onClick={handleButtonClick}
            >
              {t('intro:more_information')}
            </button>
          </p>
        </div>
      </div>
      <BankIdIcon className="w-32 h-6 flex-shrink-0" />
    </div>
  );
}

export default TopSection;
